import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getPlaybookType, getDemoRequestProductName, getDemoRequestValueProp, getDemoRequestIndustry } from 'modules/playbook/selectors'
import { createNewsletterPlaybook, createDemoRequestPlaybook } from 'modules/playbook/actions'
import OnboardingPlaybookTargetingStep from "layouts/OnboardingPlaybookTargetingStep"

const mapStateToProps = (state) => {
  return {
    playbookType: getPlaybookType(state),
    productName: getDemoRequestProductName(state),
    valueProp: getDemoRequestValueProp(state),
    industry: getDemoRequestIndustry(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    createNewsletterPlaybook,
    createDemoRequestPlaybook
  }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingPlaybookTargetingStep)


// WEBPACK FOOTER //
// ./src/containers/OnboardingPlaybook/TargetingStep/index.js